"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M44.375 5.62501C43.1066 4.36552 41.3916 3.65869 39.6041 3.65869C37.8167 3.65869 36.1017 4.36552 34.8333 5.62501L8.18747 32.2917C8.09205 32.4007 8.00826 32.5194 7.93747 32.6458C7.67815 32.8239 7.48137 33.079 7.37497 33.375L3.72914 44.2917C3.64564 44.5278 3.62014 44.7806 3.65479 45.0287C3.68944 45.2767 3.78323 45.5129 3.92823 45.7171C4.07324 45.9213 4.26523 46.0877 4.48801 46.2022C4.71078 46.3167 4.95782 46.376 5.2083 46.375C5.37436 46.3951 5.54224 46.3951 5.7083 46.375L16.6666 42.625C16.9516 42.5193 17.1983 42.3306 17.375 42.0833C17.5143 42.0124 17.6468 41.9287 17.7708 41.8333L44.375 15.1667C45.6395 13.901 46.3499 12.185 46.3499 10.3958C46.3499 8.60668 45.6395 6.89071 44.375 5.62501ZM9.47914 36.875L13.0833 40.4792L7.68747 42.2709L9.47914 36.875ZM16.1666 38.9583L11.0416 33.8542L34.3125 10.5833L39.4375 15.7083L16.1666 38.9583ZM42.1666 12.9583L41.6666 13.5L36.5208 8.33335L37.0416 7.79168C37.5449 7.263 38.1961 6.89857 38.9099 6.74608C39.6237 6.5936 40.367 6.66016 41.0423 6.93707C41.7177 7.21397 42.2938 7.68831 42.6951 8.29801C43.0964 8.9077 43.3043 9.62436 43.2916 10.3542C43.2912 10.842 43.1913 11.3245 42.9978 11.7723C42.8044 12.2201 42.5215 12.6237 42.1666 12.9583Z",
    fill: fill
  }));
};

exports["default"] = _default;